<template>
  <div class="view-container" :class="{ 'dark-mode': darkMode }">
    <alert-card-component
      v-if="showAlertCard"
      class="alert-card-component"
      :data="alertCardData"
      @hideCard="hideAlertCard"
    />

    <slot name="content" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AlertCard from '@/components/AlertCard';

export default {
  name: 'DefaultView',

  data() {
    return {
      logoPath: 'logo-im-white.webp',
      companyName: 'Instituto Mix de Profissões',
    };
  },

  computed: {
    ...mapGetters({
      getIsExternalAuth: 'authModule/getIsExternalAuth',
    }),
  },

  props: {
    showAlertCard: {
      type: Boolean,
      default: false,
    },

    hideFooter: {
      type: Boolean,
      default: false,
    },

    darkMode: {
      type: Boolean,
      default: false,
    },

    alertCardData: {
      type: Object,
      default() {
        return {
          text: 'Aconteceu um erro. Tente novamente!',
          color: '#FF5A5A',
        };
      },
    },
  },

  components: {
    'alert-card-component': AlertCard,
  },

  methods: {
    hideAlertCard() {
      this.$emit('hideAlertCard');
    },
  },

  mounted() {
    this.companyName = this.$service.getPlatformName();

    const platform = this.$service.getPlatform();
    if (platform == 'grad') {
      this.logoPath = 'logo-unim-white.webp';
    } else if (platform == 'aprovat') {
      this.logoPath = 'logo-aprovat-color.webp';
    }
  },
};
</script>

<style lang="scss" scoped>
.view-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: background-color 0.3s ease;
  padding: 0;
  margin: 0;

  .alert-card-component {
    margin-top: 0;
    position: fixed;
    z-index: 1000;
  }
}
</style>
